import { Injectable } from '@angular/core';
import { format, formatDistance, parseISO } from 'date-fns';
import { map, Observable, switchMap } from 'rxjs';
import { BaseService } from 'src/app/helpers/base.service';
import { environment } from 'src/environments/environment.development';
import { CustomerService } from '../../lead-konnekt/customer/customer.service';
import { StatusesService } from '../../setup/statuses/statuses.service';
import { iTaskReq } from 'src/app/helpers/Interfaces/task';
import { iTaskFiltrationProject } from 'src/app/helpers/Interfaces/project';
import { StopSprintRequest } from 'src/app/helpers/Interfaces/sprint';

@Injectable({
  providedIn: 'root',
})
export class ProjectsService extends BaseService {
  // Project
  private _getAllProjects = `${environment.base_url}/api/Project/GetAllWithRelationship`;
  private _getAllProjects1 = `${environment.base_url}/api/Project/GetAllWithRelationshipWithFilteration`;
  private _getProjectById = `${environment.base_url}/api/Project/GetById`;
  private _getProjects = `${environment.base_url}/api/Project/GetAll`;
  private _getProjectsByCategory = `${environment.base_url}/api/Project/GetByCategory`;
  private _getProjectsByCustomerId = `${environment.base_url}/api/Project/GetByCustomer`;
  private _addProject = `${environment.base_url}/api/Project/Add`;
  private _updateProject = `${environment.base_url}/api/Project/Update`;
  private _removeProject = `${environment.base_url}/api/Project/Remove`;
  // ProjectCustomer
  private _getProjectCustomers = `${environment.base_url}/api/ProjectCustomers/GetByProjectId`;
  private _addProjectCustomer = `${environment.base_url}/api/ProjectCustomers/Add`;
  private _removeProjectCustomer = `${environment.base_url}/api/ProjectCustomers/RemoveNew`;
  // ProjectStatus
  private _addProjectStatus = `${environment.base_url}/api/ProjectStatus/Add`;
  private _getStatusHistoryByProject = `${environment.base_url}/api/ProjectStatus/GetByProjectId`;
  // ProjectFiles
  private _addProjectFiles = `${environment.base_url}/api/ProjectFiles/AddRangeFiles`;
  private _removeProjectFIle = `${environment.base_url}/api/ProjectFiles/Remove`;
  // Conversation
  private _getConversation = `${environment.base_url}/api/Conversation/GetByProject`;
  private _getConversationById = `${environment.base_url}/api/Conversation/GetById`;
  private _addConversation = `${environment.base_url}/api/Conversation/Add`;
  private _addConversationFiles = `${environment.base_url}/api/ConversationAttachment/AddRangeFiles`;
  private _getForTaskFiltration = `${environment.base_url}/api/Project/GetNewTaskByProject`;

  // spritn Start/End api's
  private _getSprintStart =  `${environment.base_url}/api/sprint`;
  private _getSprintStop  = `${environment.base_url}/api/sprint`;


   // Project-report
  private _getEmployeeForDashboard = `${environment.base_url}/api/ProjectAndEmployeeDashBoard/GetProjectSummaryTable`
  private _getTask = `${environment.base_url}/api/ProjectAndEmployeeDashBoard/GetProjectWiseTaskSummary`
  private _getTickets = `${environment.base_url}/api/ProjectAndEmployeeDashBoard/GetProjectWiseTicketSummary`
  private _getCounts = `${environment.base_url}/api/ProjectAndEmployeeDashBoard/GetProjectWiseCount`
  private _getStatusWiseTaskCounts = `${environment.base_url}/api/ProjectAndEmployeeDashBoard/GetStatusWiseTaskCount`
  private _getStatusWiseTaskCountsWithDate = `${environment.base_url}/api/ProjectAndEmployeeDashBoard/GetStatusAndMonthWiseCount`
  private _getEmployee = `${environment.base_url}/api/Employee/GetAll`
  private _getModule = `${environment.base_url}/api/Module/GetAll`
  private _getFeature = `${environment.base_url}/api/Feature/GetAll`

  constructor(
    private _customerServ: CustomerService,
    private _statusServ: StatusesService
  ) {
    super();
  }

  private processFiles(files: any[]): any[] {
    return files.map((file) => ({
      ...file,
      name: file.fileName ?? file.name,
      size: `(${((file.fileSize ?? file.size) / 1024)
        .toFixed()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')} KB)`,
      // filePath: `${environment.base_url}/${file.filePath}`,
    }));
  }
  private transformArray(originalArray: any[]): any[] {
    const transformedArray: any[] = [];
    const productMap: { [id: string]: any } = {};
    originalArray.forEach((originalItem) => {
      const transformedItem: any = {
        id: originalItem.id,
        title: originalItem.title,
        createdDate: originalItem.createdDate,
      };

      if (originalItem.type === 'product') {
        transformedItem.collapsed = true;
        transformedItem.active = false;
        productMap[originalItem.id] = transformedItem;
        transformedItem.statuses = [];
        transformedArray.push(transformedItem);
      }
    });
    originalArray.forEach((originalItem) => {
      const transformedItem: any = {
        id: originalItem.id,
        title: originalItem.title,
        createdDate: originalItem.createdDate,
      };

      if (originalItem.type === 'project') {
        transformedItem.productId = originalItem.productId;
        transformedItem.customerId = originalItem.customerId;
        transformedItem.customer = originalItem.customer;
        const product = productMap[originalItem.productId];
        if (product) {
          const lastStatus = originalItem.lastStatus;
          const existingStatus = product.statuses.find(
            (status: any) => status.id === lastStatus.statusId
          );

          if (existingStatus) {
            existingStatus.projects.push(transformedItem);
          } else {
            const newStatus: any = {
              id: lastStatus.statusId,
              status: lastStatus.status,
              color: lastStatus.color,
              collapsed: false,
              active: false,
              projects: [transformedItem],
              // Add other fields from lastStatus as needed
            };

            product.statuses.push(newStatus);
          }
        }
      }
    });

    return transformedArray;
  }
  private processProject(project: any): any {
    project.des = `${project.description || ''}${project.description && project.body ? ' - ' : ''
      }${project.body || ''}`;
    project.createdAt = formatDistance(
      parseISO(project.createdDate),
      new Date(),
      {
        addSuffix: true,
        includeSeconds: true,
      }
    );
    project.createdDate = format(parseISO(project.createdDate), 'MMM do, yyyy');
    project.files = this.processFiles(project.files);
    if (
      project?.logo &&
      !(project?.logo as string)?.includes(environment.base_url)
    ) {
      project.logo = `${environment.base_url}/${project.logo}`;
    }
    return project;
  }
  private ShapePayload(data: any) {
    const payload = new FormData();
    if (data.id) payload.set('Id', data.id);
    payload.set('Title', data.title);
    payload.set('Type', data.type);
    payload.set('Industry', data.industry);
    payload.set('Code', data.code);
    if (data.productId) payload.set('ProductId', data.productId);
    if (data.customerId) payload.set('CustomerId', data.customerId);
    if (data.categoryId) payload.set('CategoryId', data.categoryId);
    payload.set('EstimatedCost', data.estimatedCost);
    payload.set('Extra', data.extra);
    payload.set('StartDate', data.startDate);
    payload.set('Description', data.description);
    payload.set('ETR', data.etr);
    payload.set('Body', data.body);
    return payload;
  }
  async createFile(url: string, name: string) {
    let response = await fetch(url, { mode: 'no-cors' });
    let data = await response.blob();
    let file = new File([data], name);
    return file;
  }
  private processCon(con: any): any {
    con.des = `${con.description || ''}${con.description && con.body ? ' - ' : ''
      }${con.body || ''}`;
    if (con.customerDetail) {
      con.createdBy = {
        email: con.customerDetail.contactPersonEmail,
        name: con.customerDetail.name,
      };
    } else if (con.employee) {
      con.createdBy = {
        email: con.employee.email,
        name: `${con.employee.firstName} ${con.employee.lastName}`,
      };
    }

    con.createdAt = formatDistance(parseISO(con.createdDate), new Date(), {
      addSuffix: true,
      includeSeconds: true,
    });
    con.createdDate = format(parseISO(con.createdDate), 'MMM do, yyyy');
    con.files = this.processFiles(con.conversationAttachments);
    return con;
  }

  public GetAllProjects() {
    return this._http
      .get<any>(this._getAllProjects, { responseType: 'json' })
      .pipe(
        map((projects) =>
          projects.map((project: any) => this.processProject(project))
        )
      );
  }
  public GetAllProjects1(payload: any) {
    return this._http
      .post<any>(this._getAllProjects1, payload, { responseType: 'json' })
      .pipe(
        map((projects) => {
          projects.projects.forEach((project: any) =>
            this.processProject(project)
          );
          return { ...projects };
        })
      );
  }
  public GetAllProjects2() {
    return this._http
      .get<any[]>(this._getAllProjects, {
        responseType: 'json',
      })
      .pipe(
        map((projects) =>
          projects.map((project: any) => this.processProject(project)).reverse()
        )
      )
      .pipe(map((projects) => this.transformArray(projects)));
  }

  public GetProjects(customerId?: string, type?: string) {
    return this._http
      .get<any>(
        customerId
          ? `${this._getProjectsByCustomerId}?Id=${customerId}`
          : `${this._getProjects}${type ? `?Type=${type}` : ''}`,
        { responseType: 'json' }
      )
      .pipe(
        map((projects) => {
          projects
            .map((project: any) => this.processProject(project))
            .filter((x: any) => x.active !== 'N');
          return { projects };
        })
      );
  }
  public getForTaskFiltration(dto: iTaskReq) {
    return this._http.post<iTaskFiltrationProject[]>(
      this._getForTaskFiltration,
      dto,
      {
        responseType: 'json',
      }
    );
  }

// sprint Start/End functions
public startSprint(id: string) {

  return this._http.post(
    `${this._getSprintStart}/${id}/start`,
    {},
    {
      responseType: 'json',
    }
  );
}

public stopSprint(id: string, payload: StopSprintRequest) {

  return this._http.post(
    `${this._getSprintStop}/${id}/stop`,
    payload,
    {
      responseType: 'json',
    }
  );
}


  public GetProjectsByCategory(categoryId: string) {
    return this._http
      .get<any[]>(`${this._getProjectsByCategory}?Id=${categoryId}`)
      .pipe(
        map((projects) =>
          projects
            .map((project: any) => this.processProject(project))
            .filter((x: any) => x.active !== 'N')
        )
      );
  }
  public GetProjectById(projectId: string) {
    return this._http.get<any>(`${this._getProjectById}?id=${projectId}`);
  }

  public AddProject(data: any, logo: any) {
    const payload = this.ShapePayload(data);
    if (logo) payload.append('Logo', logo);

    return this._http
      .post<any>(this._addProject, payload, {
        responseType: 'json',
      })
      .pipe(map((project) => this.processProject(project)));
  }

  public UpdateProject(data: any, logo: any) {
    const payload = this.ShapePayload(data);
    if (logo) payload.append('Logo', logo);
    return this._http
      .put<any>(this._updateProject, payload, {
        responseType: 'json',
      })
      .pipe(map((project) => this.processProject(project)));
  }

  public AddProjectFiles(Files: FormData) {
    return this._http
      .post<any>(`${this._addProjectFiles}`, Files, {
        responseType: 'json',
      })
      .pipe(map((files) => this.processFiles(files)));
  }

  public DeleteProject(id: any) {
    return this._http.delete(`${this._removeProject}?id=${id}`);
  }
  public DeleteProjectFile(id: string) {
    return this._http.delete(`${this._removeProjectFIle}?id=${id}`);
  }
  private customers: any[] = [];

  public HandleProjectCustomer(
    customerId: string,
    projectId: string,
    include: boolean
  ) {
    if (!include)
      return this._http.post(
        this._addProjectCustomer,
        { customerId, projectId },
        { responseType: 'json' }
      );
    return this._http.delete(
      `${this._removeProjectCustomer}?ProjectId=${projectId}&CustomerId=${customerId}`,
      { responseType: 'json' }
    );
  }

  public GetProjectCustomers(projectId: string) {
    if (this.customers.length > 0) {
      return this.getProjectCustomersFromCachedData(projectId);
    } else {
      return this.getProjectCustomersFromApi(projectId);
    }
  }

  private getProjectCustomersFromCachedData(projectId: string) {
    return this._http
      .get<any[]>(`${this._getProjectCustomers}?id=${projectId}`)
      .pipe(
        map((projectCustomers) => {
          const yFilter = projectCustomers.map((itemY) => itemY.customerId);
          const filteredX = this.customers.filter(
            (itemX) => !yFilter.includes(itemX.id)
          );

          const response = this.customers.map((e) => ({
            ...e,
            include: !filteredX.some((x) => x.id === e.id),
            loading: false,
          }));

          return response;
        })
      );
  }
  private getProjectCustomersFromApi(projectId: string) {
    return this._http
      .get<any[]>(`${this._getProjectCustomers}?id=${projectId}`)
      .pipe(
        switchMap((projectCustomers) => {
          return this._customerServ
            .GetAllCustomers({ skipPagination: true })
            .pipe(
              map((customers) => {
                this.customers = customers.data;
                return { projectCustomers, customers };
              })
            );
        }),
        map(({ projectCustomers, customers }) => {
          const yFilter = projectCustomers.map((itemY) => itemY.customerId);
          const filteredX = customers.data.filter(
            (itemX) => !yFilter.includes(itemX.id)
          );

          const response = customers.data.map((e) => ({
            ...e,
            include: !filteredX.some((x) => x.id === e.id),
            loading: false,
          }));

          return response;
        })
      );
  }

  public AddProjectStatus1(projectId: string) {
    const payload = {
      projectId,
      employeeId: this._dataServ.employeeValue.id,
      statusId: '',
    };
    return this._statusServ.GetStatusByName('pending').pipe(
      switchMap((status) => {
        payload.statusId = status.id;
        return this._http.post(this._addProjectStatus, payload, {
          responseType: 'json',
        });
      }),
      map((res) => {
        return res;
      })
    );
  }
  public AddProjectStatus(payload: any) {
    return this._http
      .post(this._addProjectStatus, payload, {
        responseType: 'json',
      })
      .pipe(map(this.processHistoryStatus));
  }
  private processHistoryStatus(status: any) {
    status.changedBy = status.employeeId ? status.employee : 'System';
    status.changedAt = format(
      parseISO((status.createdDate as string).replace(/[zZ]/g, '')),
      'MMM do, yyyy p'
    );
    return status;
  }
  public GetStatusHistoryByProject(id: string) {
    return this._http
      .get<Array<any>>(`${this._getStatusHistoryByProject}?Id=${id}`)
      .pipe(
        map((statuses) => statuses.map(this.processHistoryStatus).reverse())
      );
  }

  public GetConversation(projectId: string) {
    return this._http
      .get<any[]>(`${this._getConversation}?Id=${projectId}`, {
        responseType: 'json',
      })
      .pipe(
        map((conversations) =>
          conversations
            .map((conversation) => this.processCon(conversation))
            .reverse()
        )
      );
  }
  public AddConversation(payload: string) {
    return this._http.post<any>(this._addConversation, payload, {
      responseType: 'json',
    });
  }
  public AddConversationFiles(payload: any) {
    return this._http.post<any>(this._addConversationFiles, payload, {
      responseType: 'json',
    });
  }
  public GetConversationById(id: string) {
    return this._http
      .get<any>(`${this._getConversationById}?id=${id}`)
      .pipe(map((conversation) => this.processCon(conversation)));
  }

  // Project-report
  public GetEmployeeSummary(params: { ProjectId: string; ModuleId?: string; FeatureId?: string }) {
    return this._http.post<any>(this._getEmployeeForDashboard, null, { params });
  }

  public GetTaskSummary(ProjectId: string) {
    return this._http.post<any>(this._getTask, null, {
      params: { ProjectId }
    });
  }

  public GetTicketsSummary(ProjectId: string) {
    return this._http.post<any>(this._getTickets, null, {
      params: { ProjectId }
    });
  }

  public GetProjectCounts(params: { ProjectId: string; ModuleId?: string; FeatureId?: string }) {
    return this._http.post<any>(this._getCounts, null, { params });
  }

  public GetStatusWiseTaskCounts(params: { ProjectId: string; ModuleId?: string; FeatureId?: string }) {
    return this._http.post<any>(this._getStatusWiseTaskCounts, null, { params });
  }

  public GetStatusWiseTaskCountsWithDateRange(params: { ProjectId: string; year: string; ModuleId?: string; FeatureId?: string }) {
    return this._http.post<any>(this._getStatusWiseTaskCountsWithDate, null, { params });
  }

  GetEmployee(): Observable<any[]> {
    return this._http.get<any[]>(this._getEmployee);
  }

  GetModule(): Observable<any[]> {
    return this._http.get<any[]>(this._getModule);
  }

  GetFeature(): Observable<any[]> {
    return this._http.get<any[]>(this._getFeature);
  }

}
